export default __webpack_public_path__ + "static/media/icon-bw-2.f73cf489.png";